const price_ids = {
  solo_monthly: "price_1PycwnDlxFxJRvrq3CdWVfOu",
  solo_yearly: "price_1Pycy9DlxFxJRvrqi12kYb4v",
  agency_monthly: "price_1PycydDlxFxJRvrqXnBQ8xDA",
  agency_yearly: "price_1PyczIDlxFxJRvrqmIl42i2l"
};

export default price_ids;
